import React from 'react';
import { situations } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
export function Problems() {
  const general = situations[situations.length - 1];
  const specific = situations.slice(0, -1);
  return <section aria-labelledby="situaciones-title" className="w-full bg-ink-800" data-id="element-149" data-mp="1d17rcb2rdeek">
      <div className="mx-auto max-w-6xl px-5 py-16 text-center md:py-24" data-id="element-150" data-mp="1hxy9d3y4ik2m">
        <h2 id="situaciones-title" className="mx-auto max-w-3xl font-display text-3xl font-black leading-tight text-white md:text-[2.75rem]" data-id="element-151" data-mp="kbhes6grykkk">
          ¿Te encontrás con alguna de estas situaciones?
        </h2>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-3" data-id="element-152" data-mp="u7u6iysreoco">
          {specific.map(situation => <li key={situation} className="flex items-center justify-center rounded-2xl border border-ink-border bg-ink-card px-5 py-6" data-id="element-153" data-mp="z286zfma3lo7">
              <p className="text-[16px] font-medium leading-relaxed text-white" data-id="element-154" data-mp="6i9n6esp1p2v">{situation}</p>
            </li>)}
          <li className="rounded-2xl border border-brand-green/40 bg-brand-greenDeep/40 px-5 py-6 sm:col-span-2 lg:col-span-3" data-id="element-155" data-mp="6939rg0lqa3g">
            <p className="text-[16px] font-semibold leading-relaxed text-brand-greenSoft" data-id="element-156" data-mp="3smbkdcw4shit">{general}</p>
          </li>
        </ul>

        <div className="mx-auto mt-14 max-w-3xl border-t border-ink-border pt-10" data-id="element-157" data-mp="3nmyyaud33eha">
          <p className="font-display text-2xl font-bold leading-snug text-white md:text-3xl" data-id="element-158" data-mp="3jmezzngry4tk">
            No se trata solamente de saber de fútbol. Se trata de saber{' '}
            <span className="text-brand-gold" data-id="element-159" data-mp="39nz6jdu9yjgw">qué preguntar, qué analizar y cuándo tomar una decisión.</span>
          </p>
          <div className="mt-8" data-id="element-160" data-mp="34po0zfb0iv4h">
            <CtaButton data-id="element-161" data-mp="34qflnv32n8fz" />
          </div>
        </div>
      </div>
    </section>;
}